import { WebTelemetryService } from './web';
export default WebTelemetryService;
